const resumeData = {
  imagebaseurl: "",
  name: "Kevin",
  role: "Developer Advocate",
  roleDescription: "I build full-stack applications and empower developers through teaching and mentorship. My superpower: translating complex technical concepts into clear, actionable knowledge that helps developers grow and teams succeed.",
  aboutme: "I'm a technology leader with experience building scalable full-stack applications, contributing to open-source projects, and guiding engineering teams with clarity and structure. I blend hands-on development with mentorship, technical decision-making, and a passion for teaching code. Outside of work, I stay active, rollerblade, and spend time with my family.",
  address: "Miami, FL",
  email: "kevin@kevinchoi.com", // Add your email here
  phone: "", // Optional: add phone if you want
  socialLinks: [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/kevinyc/",
      className: "fa fa-linkedin"
    },
    {
      name: "GitHub",
      url: "https://github.com/kevinyc-dri",
      className: "fa fa-github"
    }
  ],
  foldAppLink: null, // Set to null to hide, or keep URL to show
  education: [
    {
      school: "Boca Code",
      degree: "Software Engineering Career Course",
      graduated: "June 2021",
      description: "Boca Code's Software Engineering Career Course focuses on the latest technology which include JavaScript, Node.js, HTML, CSS, React, Firebase and many more. On top of technical skills, Boca Code teaches soft skills that hone in on professional development, agile methodologies, team work, communication and collaboration."
    },
    {
      school: "University of Nevada, Las Vegas",
      degree: "B.S. Hotel Management",
      graduated: "June 2008",
      description: "UNLV is a doctoral-degree-granting institution of more than 30,000 students and 3,500 faculty and staff that is recognized as \"very high research activity\" by the Carnegie Classification of Institutions of Higher Education."
    }
  ],
  work: [
    {
      company: "Miami EdTech",
      title: "Lead Instructor",
      years: "March 2020 - April 2021",
      description: "Academic Coordinator and Instructor. Lead Instructor- Computer Programming, IT, Software Development, Computer Science Pedagogy, Project Management, Coding, and Web Development."
    },
    {
      company: "Launch Code",
      title: "Teaching Fellow",
      years: "July 2019 - August 2019",
      description: "Part-Time Teaching Fellow - Computer Programming, IT, Software Development, Front-end Web Development, Back-end Web Development, Project Management, Coding, and Web Development."
    },
    {
      company: "TechHire",
      title: "Lead Instructor",
      years: "June 2019 - August 2019",
      description: "TechHire lead instructor for Web-Development Course teaching HTML, CSS, JavaScript, jQuery. Led career mentorship and implemented growth mindset Pedagogy to students at Florida Memorial University."
    }
  ],
  skills: {
    description: "Full-stack development with expertise in modern JavaScript frameworks, cloud deployment, and agile methodologies. Proficient in building scalable applications, API development, database design, and DevOps practices.",
    list: [
      { name: "HTML/CSS", className: "photoshop" },
      { name: "JavaScript", className: "illustrator" },
      { name: "React", className: "wordpress" },
      { name: "Node.js", className: "css" },
      { name: "Ruby on Rails", className: "html5" },
      { name: "MongoDB/PostgreSQL", className: "jquery" }
    ]
  },
  portfolio: {
    projects: [
      {
        title: "Affirmations",
        category: "React • Firebase",
        image: "images/portfolio/affirmations.jpg",
        url: "https://affirmation-kevin.web.app/",
        github: "https://github.com/kevinyc-dri/Affirmations-App",
        description: "A daily affirmations web application built with React and Firebase. Features include user authentication, personalized affirmation collections, and a clean, inspiring user interface designed to promote positive thinking and mindfulness."
      },
      {
        title: "Resources.co",
        category: "Full-Stack • Open Source",
        image: "images/portfolio/resources-logo.jpg",
        url: "https://resources.co/",
        github: "https://github.com/ResourcesCo",
        description: "An open-source platform for sharing and discovering developer resources. Built with modern web technologies, this collaborative project helps developers find the best tools, tutorials, and learning materials."
      },
      {
        title: "Weather App",
        category: "Vue.js • API Integration",
        image: "images/portfolio/weather.jpg",
        url: "https://weather-json2.vercel.app/",
        github: "https://github.com/kevinyc-dri/weather-json2",
        description: "A responsive weather application built with Vue.js that provides real-time weather information. Features include location-based weather data, forecast displays, and a modern, intuitive user interface."
      },
      {
        title: "React SASS App",
        category: "React • SASS • Styling",
        image: "images/portfolio/sass.jpg",
        url: "https://react-sass.vercel.app/",
        github: "https://github.com/kevinyc-dri/react-sass",
        description: "A React application showcasing advanced SASS styling techniques. Demonstrates modern CSS architecture, responsive design patterns, and component-based styling best practices."
      },
      {
        title: "Garden App",
        category: "",
        image: "images/portfolio/garden.jpg",
        url: "http://vitorias-garden-js.s3-website-us-east-1.amazonaws.com/",
        github: "https://github.com/kevinyc-dri/vitorias-garden-app",
        githubBackend: "https://github.com/kevinyc-dri/vits-garden-api",
        description: "A React web application connected with MongoDB and deployed with AWS S3 bucket running on EC2 cloud server."
      },
      {
        title: "HODLgood",
        category: "",
        image: "images/portfolio/hodl.jpg",
        url: "http://dev.hodlgood.com/",
        github: "https://github.com/kevinyc-dri/coin-purchase-log",
        githubBackend: "https://github.com/kevinyc-dri/hodl-good-api",
        description: "A React web application connected with MongoDB and deployed with AWS S3 bucket running on EC2 cloud server."
      }
    ]
  },
  testimonials: [
    {
      text: "Never stop learning!",
      user: "Boca Code"
    },
    {
      text: "Kevin is a hard working and dedicated individual. He is passionate about technology having recently made the career transition to dev and scrum work. Kevin has a valuable background of running a retail clothing company in Wynwood as well as hospitality.",
      user: "Johanna Mikkola Co-Founder of Wyncode Academy"
    }
  ]
};

export default resumeData;
